import { render } from "./iconbutton.vue?vue&type=template&id=3ab450cf"
import script from "./iconbutton.vue?vue&type=script&lang=js"
export * from "./iconbutton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__